import { createRpcClientV2 } from 'rpc-client-utils';
import appAuthApiClient from 'hub-http/clients/apiClient';
import { getSettingsRpc, patchSettingsRpc, deleteSettingByKeyRpc, deleteSettingByViewAndKeyRpc } from '../../__generated__/chirp/com/hubspot/onboarding/settings/rpc/LegacyUserGuideSettingsRpc';
const rpcClient = createRpcClientV2({
  hubHttpClient: appAuthApiClient
});
export function fetchOnboardingSettings() {
  return rpcClient.call(getSettingsRpc, {
    request: {}
  });
}
export function patchOnboardingSettings(onboardingSettings) {
  return rpcClient.call(patchSettingsRpc, {
    request: {
      settings: onboardingSettings
    }
  });
}
export function removeOnboardingSettings(view, key) {
  if (!key) {
    return rpcClient.call(deleteSettingByKeyRpc, {
      request: {
        key: view
      }
    });
  }
  return rpcClient.call(deleteSettingByViewAndKeyRpc, {
    request: {
      view: view,
      key
    }
  });
}